"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _core = require("../core");
var _metaProps = require("../metaProps");
const defaultProps = {
  target: "_blank"
};

/**
 *
 * @example ../../sample-site/csvdownload.example.md
 */
class CSVDownload extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  buildURI() {
    return (0, _core.buildURI)(...arguments);
  }
  componentDidMount() {
    const {
      data,
      headers,
      separator,
      enclosingCharacter,
      uFEFF,
      target,
      specs,
      replace
    } = this.props;
    this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator, enclosingCharacter), target, specs, replace);
  }
  getWindow() {
    return this.state.page;
  }
  render() {
    return null;
  }
}
(0, _defineProperty2.default)(CSVDownload, "defaultProps", Object.assign(_metaProps.defaultProps, defaultProps));
(0, _defineProperty2.default)(CSVDownload, "propTypes", _metaProps.propTypes);
var _default = exports.default = CSVDownload;